//import React from "react";
import React, { useContext, useState, useEffect } from "react";

import { Translate, translate } from "react-i18nify";

import CloseIcon from "@mui/icons-material/Close";
import SettingsIcon from "@mui/icons-material/Settings";
import ContentCutIcon from "@mui/icons-material/ContentCut";
import BackspaceIcon from "@mui/icons-material/Backspace";

import {
  Button,
  Snackbar,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  InputAdornment
} from "@mui/material";

import { Menu, MenuItem } from "@mui/material";

import { BorderStyle, Delete } from "@mui/icons-material";

import { Capacitor } from "@capacitor/core";
import DeviceIDPlugin from "./../../../../plugin/DeviceID";
import EsponPrinterPlugin from "./../../../../plugin/EsponPrinter";

import { kioskstyles } from "./../../../../kioskstyles";
import { useKioskVerticalStyles } from "./../../../../kioskverticalstyles_2";
import "./../../../../font.css";

import { useTheme, createTheme, ThemeProvider } from "@mui/material/styles";

import { Dlog } from "./../../../../utils/Dlog";

// import PhoneKeypad from "./../SubmissionApproval/PhoneKeypad_V";
import PhoneKeypad from "./KioskIDButton/PhoneKeypad_V";

//Just for testing theme
import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";

// Using a functional component, you must wrap it in React.forwardRef, and then forward the ref to
// the node you want to be the root of the print (usually the outer most node in the ComponentToPrint)
// https://reactjs.org/docs/refs-and-the-dom.html#refs-and-function-components
function KioskIDButton(props) {
  const { customerName, label } = props;

  const [openOverwriteCode, setOpenOverwriteCode] = React.useState(false);
  const [openKioskDebug, setOpenKioskDebug] = React.useState(false);

  const [open, setOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");

  const [cutInProgress, setCutInProgress] = React.useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  //const menuopen = Boolean(anchorEl);

  const [overrideCode, setOverrideCode] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [debugInfo, setDebugInfo] = React.useState("");

  const kioskverticalstyles_2 = useKioskVerticalStyles();

  //Just for testing theme
  const {
    socketEvents,
    sendEvent,
    clearSocketEvents,
    getKioskTheme
  } = useContext(SocketIOContext);
  const kiosktheme = getKioskTheme();

  // //Logic for response from Socket.IO
  useEffect(() => {
    if (socketEvents == null) {
      Dlog("(socketEventsHandler) socketEvents is null, ignoring");
      return;
    }

    let socketdata = socketEvents.data;
    Dlog("socketdata", socketdata);

    let result = socketdata.result;
    let action = socketdata.action;

    switch (action) {
      case "CHECKKIOSKOPTIONPIN_RESULT":
        setLoading(false);
        if (result === "SUCCESS") {
          setError("");
          setDebugInfo("");
          setOpenOverwriteCode(false);
          setOpenKioskDebug(true);
          break;
        }
        if (result === "ERROR_429") {
          setError(translate("application.options.toomanyrequest"));
          break;
        }

        setError(translate("application.options.invalidcode"));
        break;
    }

    console.log("clearSocketEvents", clearSocketEvents);
    clearSocketEvents();
  }, [socketEvents]);

  const backspacepress = event => {
    if (overrideCode.length > 0) {
      setOverrideCode(overrideCode.substring(0, overrideCode.length - 1));
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleClick = event => {
    // setAnchorEl(event.currentTarget);
    setOpenOverwriteCode(true);
    setOverrideCode("");
  };

  const handleOpenDeviceID = () => {
    setDebugInfo(localStorage.getItem("kioskID"));
    //setSnackbarMessage(localStorage.getItem("kioskID"));
    //setOpen(true);
    //handleMenuClose();
  };

  const handleAndroidID = async () => {
    let deviceID = "";
    let serialID = "";

    const deviceIDPluginAvailable = Capacitor.isPluginAvailable("DeviceID");

    if (deviceIDPluginAvailable) {
      deviceID = await DeviceIDPlugin.get({});
      serialID = await DeviceIDPlugin.getEloSerial({});
      setDebugInfo(deviceID?.androidID);
      //setSnackbarMessage(JSON.stringify(deviceID));
    } else {
      setDebugInfo(translate("application.options.androidpluginunavailable"));
      //setSnackbarMessage(
      //    translate("application.options.androidpluginunavailable")
      //  );
    }
    //setOpen(true);
    //handleMenuClose();
  };

  const handleDebugTheme = async () => {
    console.log("getKioskTheme", kiosktheme);
    setDebugInfo(JSON.stringify(kiosktheme));
    //setSnackbarMessage(JSON.stringify(getKioskTheme()));
    //setOpen(true);
    //handleMenuClose();
  };

  const handlePrinterCut = async () => {
    let pluginResult = "";

    if (cutInProgress) {
      console.log("[handlePrinterCut] cutInProgress", cutInProgress);
      //return setSnackbarMessage(translate("PLEASE WAIT"));
      return;
    }

    const epsonPrinterPluginAvailable = Capacitor.isPluginAvailable(
      "EpsonPrinter"
    );

    if (epsonPrinterPluginAvailable) {
      setCutInProgress(true);
      pluginResult = await EsponPrinterPlugin.PrinterCut({});

      setTimeout(async () => {
        let value = await EsponPrinterPlugin.PrintTextOnlyWithSelectedPrinter({
          bagtags: ["TEST LABEL"]
        });

        setSnackbarMessage(translate("application.success"));
        setCutInProgress(false);
      }, 1000);
    } else {
      setSnackbarMessage(
        translate("application.options.epsonprinterpluginunavailable")
      );
    }

    setOpenKioskDebug(false);
  };

  const handlePrinterCoverCloseAutoCut = async () => {
    let pluginResult = "";

    const epsonPrinterPluginAvailable = Capacitor.isPluginAvailable(
      "EpsonPrinter"
    );

    if (epsonPrinterPluginAvailable) {
      pluginResult = await EsponPrinterPlugin.PrinterConfigCoverCloseAutoCut(
        {}
      );
      setSnackbarMessage(translate("application.success"));
    } else {
      setSnackbarMessage(
        translate("application.options.epsonprinterpluginunavailable")
      );
    }

    setOpenKioskDebug(false);
  };

  const handleGetPrinterStatus = async () => {
    let pluginResult = "";

    if (cutInProgress) {
      console.log("[handlePrinterCut] cutInProgress", cutInProgress);
      //return setSnackbarMessage(translate("PLEASE WAIT"));
      return;
    }

    const epsonPrinterPluginAvailable = Capacitor.isPluginAvailable(
      "EpsonPrinter"
    );

    if (epsonPrinterPluginAvailable) {
      setCutInProgress(true);
      pluginResult = await EsponPrinterPlugin.getPrinterStatus({});

      let string =
        "connection:" +
        pluginResult.connection +
        "\r\n" +
        "online:" +
        pluginResult.online +
        "\r\n" +
        "coverOpen:" +
        pluginResult.coverOpen +
        "\r\n" +
        "paper:" +
        pluginResult.paper +
        "\r\n" +
        "paperFeed:" +
        pluginResult.paperFeed +
        "\r\n" +
        "waitOnline:" +
        pluginResult.waitOnline +
        "\r\n" +
        "drawer:" +
        pluginResult.drawer +
        "\r\n" +
        "errorStatus:" +
        pluginResult.errorStatus +
        "\r\n" +
        "autoRecoverError:" +
        pluginResult.autoRecoverError +
        "\r\n" +
        "buzzer:" +
        pluginResult.buzzer +
        "\r\n";

      setDebugInfo(string);

      setSnackbarMessage(translate("application.success"));
      setCutInProgress(false);
    } else {
      setSnackbarMessage(
        translate("application.options.epsonprinterpluginunavailable")
      );
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleOverwriteCodeClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenOverwriteCode(false);
    setError("");
  };

  const handleKioskDebugClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenKioskDebug(false);
  };

  const handleCopy = event => {
    navigator.clipboard
      .writeText(snackbarMessage)
      .then(() => {})
      .catch(err => {});
  };

  const vtheme = createTheme({
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            ...{
              height: "8vh",
              width: "32vh",
              fontSize: "6vh"
            }
          }),
          input: ({ ownerState }) => ({
            ...{
              textAlign: "center"
            }
          })
        }
      }
    }
  });

  const submitOverrideCodeFunc = () => {
    const payload = {
      type: "CHECKKIOSKOPTIONPIN",
      payload: {
        overrideCode: overrideCode
      }
    };

    sendEvent(payload);
    setLoading(true);
  };

  const clearError = async () => {
    setError("");
  };

  const action = (
    <React.Fragment>
      <Button color="secondary" size="small" onClick={handleCopy}>
        COPY
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <div
      class="fontSecondaryText"
      style={{ position: "absolute", top: "1vh", left: "1vh" }}
    >
      <IconButton
        onClick={handleClick}
        sx={{
          width: "5.5vh", // Button size
          height: "5.5vh", // Button size
          "& svg": {
            // Icon size
            fontSize: "3.3vh"
          }
        }}
      >
        <SettingsIcon />
      </IconButton>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleMenuClose}
        message={snackbarMessage}
        action={action}
      />
      {/* Overwrite Code Dialog */}
      <Dialog
        open={openOverwriteCode}
        onClose={handleOverwriteCodeClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{ overflow: "none" }}
        // sx={{ width: "67vw" }}
        sx={{
          "& .MuiDialogTitle-root": {
            padding: "2.25vh 3vh"
          },
          "& .MuiDialog-paper": { width: "67vh" },
          "& .MuiDialogContent-root": {
            overflow: "hidden"
          }
        }}
      >
        <DialogTitle id="alert-dialog-title">
          <div
            style={{
              fontSize: "3vh",
              fontWeight: "500",
              marginBottom: "1vh",
              textAlign: "center",
              width: "100%"
            }}
          >
            <Translate value="application.adminoptions.accesscoderequired" />
          </div>
          <div
            style={{
              fontSize: "2vh",
              fontWeight: "400",
              marginBottom: "1vh",
              textAlign: "center",
              width: "100%"
            }}
          >
            <Translate value="application.adminoptions.instructions" />
          </div>
        </DialogTitle>
        <DialogContent>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              overflow: "hidden"
              // paddingLeft: "3vh",
              // paddingRight: "3vh"
            }}
          >
            <ThemeProvider theme={vtheme}>
              <TextField
                id="KioskOptionsKey"
                label=""
                type="password"
                value={overrideCode}
                style={{
                  marginBottom: "3vh"
                }}
                onChange={event => {
                  let newText = event.target.value;
                  newText = newText.toUpperCase().trim();
                  setOverrideCode(newText);
                }}
                inputProps={{
                  readOnly: true,
                  style: { cursor: "pointer" } // Optional: keeps the cursor visible
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          backspacepress();
                        }}
                        edge="end"
                      >
                        <BackspaceIcon style={{ fontSize: "3.8vh" }} />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "white"
                  }
                }}
              />
            </ThemeProvider>
            <PhoneKeypad
              phonenumber={overrideCode}
              setPhonenumber={setOverrideCode}
              keypadDone={submitOverrideCodeFunc}
              loading={loading}
              errorMessage={error}
              clearErrorFunc={clearError}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              paddingBottom: "2vh"
            }}
          >
            <Button
              variant="contained"
              onClick={handleOverwriteCodeClose}
              style={{
                // borderRadius: "1vi",
                // textTransform: "capitalize",
                // //marginRight: "1.25vw",
                // padding: "0.5vw 2vw 0.5vw 1.5vw",
                // backgroundColor: kiosktheme.configCloseBGColor,
                // color: kiosktheme.configCloseTextColor,
                // height: "3.9vh",
                // width: "19vw",
                // minWidth: "0vh",
                // fontSize: "2vh"
                ...kioskverticalstyles_2.languagebutton.languagebuttonwidget,
                marginBottom: "0px",
                marginTop: "0px"
              }}
            >
              <Translate value="application.close" />
            </Button>
          </div>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openKioskDebug}
        onClose={handleKioskDebugClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{ overflow: "none" }}
      >
        <DialogTitle id="alert-dialog-title">
          <div
            style={{
              fontSize: "3vh",
              fontWeight: "500",
              marginBottom: "1vh",
              textAlign: "center",
              width: "100%"
            }}
          >
            <Translate value="application.adminoptions.optionmenutitle" />
          </div>
        </DialogTitle>
        <DialogContent>
          <MenuItem
            style={{
              backgroundColor: "#555",
              color: "white",
              margin: "1vh",
              fontSize: "2.25vh",
              padding: "0.8vh 2.2vh"
            }}
            onClick={handleOpenDeviceID}
          >
            <Translate value="application.adminoptions.kioskid" />
          </MenuItem>
          <MenuItem
            style={{
              backgroundColor: "#555",
              color: "white",
              margin: "1vh",
              fontSize: "2.25vh",
              padding: "0.8vh 2.2vh"
            }}
            onClick={handleAndroidID}
          >
            <Translate value="application.adminoptions.androidid" />
          </MenuItem>
          {/* <MenuItem
            style={{
              backgroundColor: "#555",
              color: "white",
              margin: "1vh",
              fontSize: "2.25vh",
              padding: "0.8vh 2.2vh"
            }}
            onClick={handleDebugTheme}
          >
            <Translate value="application.adminoptions.testtheme" />
          </MenuItem> */}
          <MenuItem
            // style={{
            //   backgroundColor: "#555",
            //   color: "white",
            //   margin: "1vh",
            //   fontSize: "2.25vh",
            //   padding: "0.8vh 2.2vh"
            // }}
            style={{
              ...kioskverticalstyles_2.languagebutton.languagebuttonwidget,
              backgroundColor: "green",
              marginBottom: "0px",
              marginTop: "0px"
            }}
            disabled={cutInProgress}
            onClick={handlePrinterCut}
          >
            <ContentCutIcon
              style={{
                fontSize: "2.2vh",
                marginRight: "0.5vh",
                height: "100%"
                //alignSelf: "end"
              }}
            />
            <Translate value="application.adminoptions.printercut" />
          </MenuItem>
          {/* <MenuItem
            style={{
              backgroundColor: "#555",
              color: "white",
              margin: "1vh",
              fontSize: "2.25vh",
              padding: "0.8vh 2.2vh"
            }}
            onClick={() => {
              sessionStorage.setItem("charitiesJSON", null);
            }}
          >
            <Translate value="application.adminoptions.clearcharitiescache" />
          </MenuItem>
          <MenuItem
            style={{
              backgroundColor: "#555",
              color: "white",
              margin: "1vh",
              fontSize: "2.25vh",
              padding: "0.8vh 2.2vh"
            }}
            onClick={() => {
              setDebugInfo(sessionStorage.getItem("charitiesJSON"));
            }}
          >
            <Translate value="application.adminoptions.viewcharitiescache" />
          </MenuItem>
          <MenuItem
            style={{
              backgroundColor: "#555",
              color: "white",
              margin: "1vh",
              fontSize: "2.25vh",
              padding: "0.8vh 2.2vh"
            }}
            onClick={() => {
              handleGetPrinterStatus();
            }}
          >
            <Translate value="application.adminoptions.getprinterstatus" />
          </MenuItem> */}
          {/* <MenuItem
            style={{
              backgroundColor: "#555",
              color: "white",
              margin: "1vh"
            }}
            onClick={handlePrinterCoverCloseAutoCut}
          >
            Configure Cover Close AutoCut
          </MenuItem> */}
          <TextField
            id="debugInfo"
            value={debugInfo}
            multiline
            fullWidth
            rows={3}
            style={{
              marginTop: "1vh",
              marginBottom: "1vh"
            }}
            sx={{
              height: "10vh",
              "& .MuiInputBase-root": {
                height: "100%",
                lineHeight: "2.5vh"
              },
              "& .MuiInputBase-input": {
                fontSize: "2vh",
                textAlign: "center"
              },
              "& .MuiOutlinedInput-root": {
                backgroundColor: "white"
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              paddingBottom: "2vh"
            }}
          >
            <Button
              variant="contained"
              onClick={handleKioskDebugClose}
              style={{
                // fontSize: "2.3vh",
                // borderRadius: "1.2vh",
                // textTransform: "capitalize",
                // //marginRight: "1.25vw",
                // padding: "0.5vw 2vw 0.5vw 1.5vw",
                // backgroundColor: kiosktheme.configCloseBGColor,
                // color: kiosktheme.configCloseTextColor,
                // height: "3.9vh",
                // width: "19vw",
                // minWidth: "0vh"
                ...kioskverticalstyles_2.languagebutton.languagebuttonwidget,
                marginBottom: "0px",
                marginTop: "0px"
              }}
            >
              <Translate value="application.close" />
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default KioskIDButton;
